import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import onboard from './web3-onboard';
import { WalletProvider } from './walletContext';
import { Web3OnboardProvider } from '@web3-onboard/react';

if (window.self !== window.top) {
  console.warn('🧱 Inside sandboxed iframe — aborting React app mount');
  // Optional: return or exit early
}


// 🔁 Wrap App in Web3 + WalletProvider
const WrappedApp = () => (
  <Web3OnboardProvider web3Onboard={onboard}>
    <WalletProvider>
      <App />
    </WalletProvider>
  </Web3OnboardProvider>
);

// ✅ Safely assign globals immediately
if (typeof window !== 'undefined') {
  window.React = React;
  window.ReactDOM = ReactDOM;
  window.App = WrappedApp; // ✅ Assign the component, not a function that returns it
  console.log('✅ Exposed window.App to global scope');
}

// 🔁 Optional mount logic (standalone rendering or for Shopify drawer events)
let walletMounted = false;

const sharedProvider = (component) => (
  <React.StrictMode>
    <Web3OnboardProvider web3Onboard={onboard}>
      <WalletProvider>{component}</WalletProvider>
    </Web3OnboardProvider>
  </React.StrictMode>
);

const mountWallet = () => {
  // 🛡 Skip if in iframe (Shopify pixels, chat iframes, etc.)
  if (window.self !== window.top) {
    console.warn('⛔️ Skipping mount — inside sandboxed iframe');
    return;
  }

  const rootEl = document.getElementById('root');
  const walletConnectRoot = document.getElementById('wallet-connect-root');
  const mobileWalletConnect = document.getElementById('mobile-wallet-connect');

  if (rootEl && !rootEl.hasChildNodes()) {
    ReactDOM.createRoot(rootEl).render(sharedProvider(<App />));
    walletMounted = true;
  }
  if (walletConnectRoot && !walletConnectRoot.hasChildNodes()) {
    ReactDOM.createRoot(walletConnectRoot).render(sharedProvider(<App />));
    walletMounted = true;
  }
  if (mobileWalletConnect && !mobileWalletConnect.hasChildNodes()) {
    ReactDOM.createRoot(mobileWalletConnect).render(sharedProvider(<App />));
    walletMounted = true;
  }
};

// 🧩 Remount when drawer opens
document.addEventListener('drawer:open', () => {
  if (!walletMounted) mountWallet();
});

// 🧩 Try once DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    if (!walletMounted) mountWallet();
  }, 500);
});

reportWebVitals();













